var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{ref:"input",attrs:{"transform-model":true,"autofocus":_vm.autofocus,"placeholder":_vm.placeholder,"parse":_vm.parse,"search":_vm.search,"min-characters":2,"is-loading":_vm.loading},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }